(function () {
  'use strict';

  if (window.navyCcScan && window.navyCcScan.isSharedInitializer) {
    window.navyCcScan();
    return;
  }

  function getElements(root, selector) {
    var scope = root && typeof root.querySelectorAll === 'function' ? root : document;
    var elements = Array.from(scope.querySelectorAll(selector));

    if (scope !== document && scope.matches && scope.matches(selector)) {
      elements.unshift(scope);
    }

    return elements;
  }

  function initStyleThumbs(root) {
    getElements(root, '.navy-cc-style-thumbs').forEach(function (container) {
      if (container._ready) return;
      container._ready = true;

      var thumbs = Array.from(container.querySelectorAll('.navy-cc-style-thumb'));
      var moreBtn = container.querySelector('.navy-cc-style-thumb-more');
      if (thumbs.length === 0) return;

      var card = container.closest('.product-item');
      if (!card) return;
      var styleOverlay = card.querySelector('.navy-cc-card__img--style-overlay');

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('mouseenter', function () {
          var src = this.dataset.imgSrc;
          if (!src || !styleOverlay) return;
          styleOverlay.src = src;
          styleOverlay.style.opacity = '1';
        });
      });

      container.addEventListener('mouseleave', function () {
        if (styleOverlay) styleOverlay.style.opacity = '';
      });

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var url = this.dataset.productUrl;
          if (url) window.location.href = url;
        });
      });

      if (moreBtn) {
        moreBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          var url = container.dataset.currentUrl;
          if (url) window.location.href = url;
        });
      }
    });
  }

  function prepareCcVideo(video) {
    video.muted = true;
    video.loop = true;
    video.controls = false;
    video.preload = 'metadata';
    video.setAttribute('muted', 'muted');
    video.setAttribute('loop', 'loop');
    video.removeAttribute('controls');
    video.setAttribute('playsinline', 'playsinline');
    video.setAttribute('webkit-playsinline', 'webkit-playsinline');
  }

  function getActiveSlide(slider) {
    return slider.querySelector('.navy-cc-card__img--slide.is-active');
  }

  function isActiveCcVideo(video) {
    var slider = video.closest('.navy-cc-card__img-slider');
    var slide = video.closest('.navy-cc-card__video-slide');

    return !!(slider && slider._videoVisible && slide && slide.classList.contains('is-active'));
  }

  function playCcVideo(video, attempt) {
    var playPromise;

    if (!video || !isActiveCcVideo(video)) return;

    prepareCcVideo(video);
    video.preload = 'auto';
    video.autoplay = true;
    video.setAttribute('autoplay', 'autoplay');

    try {
      playPromise = video.play();
    } catch (error) {
      playPromise = null;
    }

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        if (attempt < 8) {
          setTimeout(function () {
            playCcVideo(video, attempt + 1);
          }, 200);
        }
      });
    } else if (video.paused && attempt < 8) {
      setTimeout(function () {
        playCcVideo(video, attempt + 1);
      }, 200);
    }
  }

  function pauseCcVideos(slider, activeVideo) {
    slider.querySelectorAll('video.navy-cc-card__video').forEach(function (video) {
      if (video === activeVideo) return;
      try {
        video.pause();
      } catch (error) {}
    });
  }

  function loadCcVideo(slide, shouldPlay) {
    var src = slide.dataset.navyCcVideoSrc;
    var type = slide.dataset.navyCcVideoType || 'video/mp4';
    var poster = slide.dataset.navyCcVideoPoster;
    var label = slide.dataset.navyCcVideoLabel;
    var video = slide.querySelector('video.navy-cc-card__video');
    var source;

    if (!src) return null;

    if (!video) {
      video = document.createElement('video');
      video.className = 'navy-cc-card__video card-video-lazy';
      video.poster = poster || '';
      video.setAttribute('aria-label', label || '');
      prepareCcVideo(video);

      source = document.createElement('source');
      source.src = src;
      source.type = type;
      video.appendChild(source);
      slide.appendChild(video);

      video.addEventListener('loadedmetadata', function () {
        if (video._shouldPlay) playCcVideo(video, 0);
      });
      video.addEventListener('loadeddata', function () {
        if (video._shouldPlay) playCcVideo(video, 0);
      });
      video.addEventListener('canplay', function () {
        if (video._shouldPlay) playCcVideo(video, 0);
      });
    }

    prepareCcVideo(video);

    if (shouldPlay) {
      video._shouldPlay = true;
      playCcVideo(video, 0);
    }

    return video;
  }

  function syncCcSliderVideo(slider, shouldPlay) {
    var activeSlide = getActiveSlide(slider);
    var activeVideo = null;

    if (!slider._videoVisible || !activeSlide) return;

    if (activeSlide.matches('[data-navy-cc-video-src]')) {
      activeVideo = loadCcVideo(activeSlide, shouldPlay);
    }

    pauseCcVideos(slider, activeVideo);
  }

  function initCcVideoObserver(slider) {
    if (slider._videoObserverReady || !slider.querySelector('[data-navy-cc-video-src]')) return;
    slider._videoObserverReady = true;

    if ('IntersectionObserver' in window) {
      slider._videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            slider._videoVisible = false;
            pauseCcVideos(slider);
            return;
          }

          slider._videoVisible = true;
          syncCcSliderVideo(slider, true);
        });
      }, {
        rootMargin: '300px 0px'
      });

      slider._videoObserver.observe(slider);
    } else {
      slider._videoVisible = true;
      syncCcSliderVideo(slider, true);
    }
  }

  function initCardSlider(root) {
    getElements(root, '.navy-cc-card__img-slider').forEach(function (slider) {
      if (slider._ready) return;
      slider._ready = true;

      var images = Array.from(slider.querySelectorAll('.navy-cc-card__img--slide'));
      initCcVideoObserver(slider);
      syncCcSliderVideo(slider, true);

      if (images.length <= 1) return;

      var wrapper = slider.closest('.card-product__wrapper');
      if (!wrapper) return;
      var prevBtn = wrapper.querySelector('.navy-cc-card__arrow--prev');
      var nextBtn = wrapper.querySelector('.navy-cc-card__arrow--next');
      var current = 0;

      function goTo(index) {
        images[current].classList.remove('is-active');
        current = (index + images.length) % images.length;
        images[current].classList.add('is-active');
        syncCcSliderVideo(slider, true);
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          goTo(current - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          goTo(current + 1);
        });
      }

      var touchTarget = slider.closest('.navy-cc-card__media') || slider;
      var touchStartX = 0;

      touchTarget.addEventListener('touchstart', function (event) {
        touchStartX = event.touches[0].clientX;
      }, { passive: true });

      touchTarget.addEventListener('touchend', function (event) {
        var dx = event.changedTouches[0].clientX - touchStartX;
        if (Math.abs(dx) > 30) goTo(dx < 0 ? current + 1 : current - 1);
      }, { passive: true });
    });
  }

  function scan(root) {
    initStyleThumbs(root);
    initCardSlider(root);
  }

  function observeDynamicCards() {
    if (!('MutationObserver' in window) || !document.documentElement) return;

    var cardSelector = '.navy-cc-style-thumbs, .navy-cc-card__img-slider';
    var pendingRoots = [];
    var scanScheduled = false;

    function scheduleScan(root) {
      if (pendingRoots.indexOf(root) === -1) pendingRoots.push(root);
      if (scanScheduled) return;
      scanScheduled = true;

      var runScan = function () {
        var roots = pendingRoots.slice();
        pendingRoots.length = 0;
        scanScheduled = false;
        roots.forEach(scan);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(runScan);
      } else {
        window.setTimeout(runScan, 16);
      }
    }

    var observer = new MutationObserver(function (records) {
      records.forEach(function (record) {
        Array.from(record.addedNodes).forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches(cardSelector) || node.querySelector(cardSelector)) {
            scheduleScan(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  scan.isSharedInitializer = true;
  window.navyCcScan = scan;
  observeDynamicCards();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    }, { once: true });
  } else {
    scan(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target);
  });
})();
